import React from 'react';
import styled, { css } from 'styled-components';

const buttonStyles = css`
    width: ${({ width }) => (width ? width : null)};
    height: ${({ height }) => (height ? height : null)};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    padding: ${({ size }) => {
        if (size === 'xs') return '10px 16px';
        if (size === 's') return '13px 20px';
        if (size === 'm') return '16px 24px';
        if (size === 'l') return '19px 32px';
        return 0;
    }};
    font-family: inherit;
    text-decoration: none;
    background: none;
    cursor: pointer;
    z-index: 1;

    &:hover {
        transition: all 0.3s ease-in-out;
        transform: scale(1.05);
    }
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    color: #FFFFFF;
    background-color: #000000;
    border-radius: 10rem;

    svg {
        path {
            fill: #FFFFFF;
        }
    }

    &:hover {
        background-color: #222222;
    }

    &:focus,
    &:focus-visible {
        box-shadow: 0 0 0 3px #62B5E5;
        outline: none;
    }

    &:disabled {
        color: #53565A;
        background-color: #D0D0CE;
        cursor: default;

        svg {
            path {
                fill: #53565A;
            }
        }
    }
`;

export const StyledButton = styled.button`
    ${buttonStyles}
`;

export const Button = (props) => {
    const { children, variant, size, onClick, ...rest } = props;

    return (
        <StyledButton variant={variant} size={size} onClick={onClick} {...rest}>
            {children}
        </StyledButton>
    );
};